<template>
    <div class="homeBox">
        <div class="flex-box">

            <HomeIconBoxDetail
                v-if="shopTag && null != userInfoRef.acccompanycode"
                :label="i18n.tkey('lang_my_3D_shop')"
                :detail="i18n.tkey('lang_3d_shop_des')"
                @click="clickView('shop')"
                tkey="3D店鋪"
            >
                <font-awesome-icon icon="fa-solid fa-shop" />
            </HomeIconBoxDetail>

<!--            <div class="content-icon-box">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-shop" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="3D店鋪">{{i18n.tkey("lang_my_3D_shop")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的店鋪">{{i18n.tkey("lang_3d_shop_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <HomeIconBoxDetail
                v-if="userInfoRef.addinfo6 == -1 && null == userInfoRef.acccompanycode"
                :label="i18n.tkey('lang_open_shop_3d')"
                :detail="i18n.tkey('lang_3d_shop_des')"
                @click="clickView('openShop')"
                tkey="開通店鋪"
            >
                <font-awesome-icon icon="fa-solid fa-shop" />
            </HomeIconBoxDetail>

<!--            <div class="content-icon-box" @click="clickView('openShop')" v-if="userInfoRef.addinfo6 == -1 && null == userInfoRef.acccompanycode">-->
<!--                <div>-->
<!--                    <div class="icon-part">-->
<!--                        <font-awesome-icon icon="fa-solid fa-shop" />-->
<!--                    </div>-->

<!--                    <div class="title-part">-->
<!--                        <span tkey="開通店鋪">{{i18n.tkey("lang_open_shop_3d")}}</span>-->
<!--                    </div>-->

<!--                    <div class="text-part">-->
<!--                        <span tkey="查看及管理您的店鋪">{{i18n.tkey("lang_3d_shop_des")}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_hall_manager_1')"
                :detail="i18n.tkey('lang_my_hall_des')"
                @click="clickView('hall')"
                tkey="展會管理"
            >
                <font-awesome-icon icon="fa-solid fa-users" />
            </HomeIconBoxDetail>

            <a :href="managerUrl" target="eshopopee" v-if="shopTag && hideEshopopeeFlag">
                <HomeIconBoxDetail
                    :label="i18n.tkey('lang_company_manage_sys')"
                    :detail="i18n.tkey('lang_manage_sys_des')"
                    tkey="企業管理系統"
                >
                    <font-awesome-icon icon="fa-solid fa-people-roof" />
                </HomeIconBoxDetail>

<!--                <div class="content-icon-box">-->
<!--                    <div>-->
<!--                        <div class="icon-part">-->
<!--                            <font-awesome-icon icon="fa-solid fa-people-roof" />-->
<!--                        </div>-->

<!--                        <div class="title-part">-->
<!--                            <span tkey="企業管理系統">{{i18n.tkey("lang_company_manage_sys")}}</span>-->
<!--                        </div>-->

<!--                        <div class="text-part">-->
<!--                            <span tkey="查看及管理您的後台中心">{{i18n.tkey("lang_manage_sys_des")}}</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </a>

            <HomeIconBoxDetail
                :label="i18n.tkey('lang_mall_manage')"
                :detail="i18n.tkey('lang_mall_manage_des')"
                v-if="shopTag"
                @click="clickView('mallManager')"
                tkey="商場管理"
            >
                <font-awesome-icon icon="fa-solid fa-basket-shopping" />
            </HomeIconBoxDetail>

          <a
              :href="webAIChatSettingUrl"
              target="eshopopee"
              v-if="shopTag && hideEshopopeeFlag">
            <HomeIconBoxDetail
                :label="'AIChat'+i18n.tkey('lang_setting')"
                :detail="'AIChat'+i18n.tkey('lang_setting')"
                tkey="AIChat設置"
            >
              <font-awesome-icon icon="fa-solid fa-comments" />
            </HomeIconBoxDetail>

          </a>
<!--            <HomeIconBoxDetail-->
<!--                :label="i18n.tkey('lang_island_manage')"-->
<!--                :detail="i18n.tkey('lang_island_manage_des')"-->
<!--                v-if="shopTag && islandFlag"-->
<!--                @click="clickView('islandManager')"-->
<!--                tkey="島嶼管理"-->
<!--            >-->
<!--                <font-awesome-icon icon="fa-solid fa-mountain-city" />-->
<!--            </HomeIconBoxDetail>-->

<!--            <a :href="saleUrl" target="eshopopee" v-if="shopTag">-->
<!--                <HomeIconBoxDetail-->
<!--                    :label="i18n.tkey('lang_order_i_received')"-->
<!--                    :detail="i18n.tkey('lang_order_i_received_des')"-->
<!--                    tkey="我收的單"-->
<!--                >-->
<!--                    <font-awesome-icon icon="fa-solid fa-file-lines" />-->
<!--                </HomeIconBoxDetail>-->

<!--&lt;!&ndash;                <div class="content-icon-box">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="icon-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <font-awesome-icon icon="fa-solid fa-file-lines" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->

<!--&lt;!&ndash;                        <div class="title-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span tkey="我收的單">{{i18n.tkey("lang_order_i_received")}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->

<!--&lt;!&ndash;                        <div class="text-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span tkey="查看和管理我收的單">{{i18n.tkey("lang_order_i_received_des")}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--            </a>-->

<!--            <a :href="purchaseUrl" target="eshopopee" v-if="shopTag">-->
<!--                <HomeIconBoxDetail-->
<!--                    :label="i18n.tkey('lang_order_i_placed')"-->
<!--                    :detail="i18n.tkey('lang_order_i_placed_des')"-->
<!--                    tkey="我下的單"-->
<!--                >-->
<!--                    <font-awesome-icon icon="fa-solid fa-file" />-->
<!--                </HomeIconBoxDetail>-->

<!--&lt;!&ndash;                <div class="content-icon-box">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="icon-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <font-awesome-icon icon="fa-solid fa-file" />&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->

<!--&lt;!&ndash;                        <div class="title-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span tkey="我下的單">{{i18n.tkey("lang_order_i_placed")}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->

<!--&lt;!&ndash;                        <div class="text-part">&ndash;&gt;-->
<!--&lt;!&ndash;                            <span tkey="查看和管理我下的單">{{i18n.tkey("lang_order_i_placed_des")}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--            </a>-->

        </div>
    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGlobe, faShop, faUsers, faAddressCard, faPeopleRoof, faGear, faFileInvoiceDollar, faComments, faFileLines, faFile, faMountainCity, faBasketShopping } from '@fortawesome/free-solid-svg-icons'
import {inject, computed, toRef, getCurrentInstance, ref, onBeforeMount, onMounted} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import HomeIconBoxDetail from "@/components/shopopee/common/homeIconBoxDetail.vue";
import {useCompanyinfo} from "@/stores/companyinfo";
import HomeIconBoxShadow from "@/components/shopopee/common/homeIconBoxShadow.vue";
import eshopopeeApi from "@/request/eshopopeeApi";

library.add(faGlobe, faShop, faUsers, faAddressCard, faPeopleRoof, faGear, faFileInvoiceDollar, faComments, faFileLines, faFile, faMountainCity, faBasketShopping)

const emits = defineEmits(["clickIcon"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())
//響應機制的companyinfo
const companyInfoRef = toRef(useCompanyinfo())
const { proxy } = getCurrentInstance()

const companyObj = ref({})
// const hasAIChat = ref("0")


const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return userInfoRef.value } })

// const websiteUrl = computed(() => {
//     let url = myUtil.generateEShopopeeShopUrl(userInfoRef.value.acccompanycode)
//     return url
// })

const managerUrl = computed(() => {
    const url = myUtil.generateEshopopeeManagerUrl(companyObj.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword)
    return url
})

const shopTag = computed(() => {
    let flag = myUtil.isNotEmpty(userInfoRef.value.acccompanycode) && userInfoRef.value.addinfo6 == -1

    return flag
})
const webAIChatSettingUrl = computed(() => {
  const host = myUtil.isEmpty(companyObj.value.currentcapital) ? proxy.$EShopopeeUrl : companyObj.value.currentcapital

  return myUtil.generateEshopopeeManagerJumpUrl(companyObj.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "MemberAIChatSetting.asp?shopForm=shopopee", host)
})


// const mallFlag = computed(() => {
//     let flag = (null != companyInfoRef.value.additionalrecord11 && null != companyInfoRef.value.additionalrecord11.mallNum && companyInfoRef.value.additionalrecord11.mallNum > 0)
//
//     return flag
// })

// const islandFlag = computed(() => {
//     let flag = (null != companyInfoRef.value.additionalrecord11 && null != companyInfoRef.value.additionalrecord11.islandNum && companyInfoRef.value.additionalrecord11.islandNum > 0)
//
//     return flag
// })

// const saleUrl = computed(() => {
//     const host = myUtil.isEmpty(companyObj.value.currentcapital) ? proxy.$EShopopeeUrl : companyObj.value.currentcapital
//
//     return myUtil.generateEshopopeeManagerJumpUrl(companyObj.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "CRMSalesRecords.asp", host)
// })
//
// const purchaseUrl = computed(() => {
//     const host = myUtil.isEmpty(companyObj.value.currentcapital) ? proxy.$EShopopeeUrl : companyObj.value.currentcapital
//
//     return myUtil.generateEshopopeeManagerJumpUrl(companyObj.value.acccompanycode, userInfoRef.value.businessLogin, userInfoRef.value.businessPassword, "SupplyPurchaseRecords.asp", host)
// })

const hideEshopopeeFlag = computed(() => {
    let flag = false

    flag = companyInfoRef.value.dinumber == -1

    return !flag
})

/*function getAIChatState(){
  const request = eshopopeeApi.getAIChatState
  const params = request.getParams()

  params.CompanyCode = companyObj.value.acccompanycode
  params.Login = userInfoRef.value.login

  request.send(params, (res) => {
    if (res.code == 200){
      const data = res.detail
      hasAIChat.value = ""+data

    }
  })

}*/
function clickView(name){
    emits("clickIcon", name)
}
/*onMounted(() => {
  setTimeout(function (){

    console.log(companyObj.value.acccompanycode)
    if (companyObj.value!=null && myUtil.isNotEmpty(companyObj.value.acccompanycode)){

      getAIChatState()
    }
  },600)

})*/

onBeforeMount(() => {
    companyObj.value = getShopCompanyObj()

})

</script>

<style scoped>

.homeBox {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
}
@media screen and (min-width: 520px) {
    .flex-box {
        display: flex;
        flex-wrap: wrap;
        word-break: break-all;
    }
}

@media screen and (max-width: 520px) {
    .flex-box {
        display: flex;
        flex-wrap: wrap;
        word-break: break-all;
        justify-content: center;
    }
}

a:-webkit-any-link {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}

a {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}
</style>